import { Auth, I18n } from "aws-amplify";
import QRCode from "react-qr-code";
import React, { useEffect, useRef, useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";

import { authService } from "../../../../../services";
import mfa_qr from "../../../../../assets/images/mfa_qr.png";
import "./mfaDevice.css";
import { DmButton, DmMessage } from "dm-react-ui";
import CodeInput from "../../../../components/CodeInput/CodeInput";

const MfaDevice = ({ user, finishRegistrer }) => {
  const [code, setCode] = useState(null);
  const [verifingCode, setVerifingCode] = useState(false);
  const [finishRegister, setFinishRegister] = useState(false);
  const hidedSubmitButtonRef = useRef(false);

  const [messageData, setMessageData] = useState(null);
  const [showMessage, setShowMessage] = useState(false);

  function showMessageInfo() {
    return (
      <DmMessage
        messageText={I18n.get(messageData.mText)}
        descriptionText={I18n.get(messageData.dText)}
        type={messageData.type}
        key={``}
        duration={messageData.duration || 5}
      />
    );
  }

  useEffect(() => {
    authService.getMfaDeviceCode(user).then((data) => {
      const str =
        "otpauth://totp/AWSCognito:" +
        user.attributes.email +
        "?secret=" +
        data +
        "&issuer=Datamart";
      setCode(str);
    });
  }, []);

  function submitCodehandler(inputCode) {
    setVerifingCode(true);
    setShowMessage(false);
    authService
      .verifyMfaDeviceCode(user, inputCode)
      .then((data) => {
        if ((data.Status = "SUCCESS")) {
          setShowMessage(false);
          Auth.setPreferredMFA(user, "TOTP")
            .then((data) => {
              setVerifingCode(false);
              setMessageData({
                type: "success",
                mText: I18n.get("Registration successful!"),
                dText: I18n.get(
                  "You can now login with your new device. You will be redirected in a moment."
                ),
                key: "success-register",
                duration: 4,
              });
              setShowMessage(true);
              setFinishRegister(true);
              finishRegistrer();
            })
            .catch((err) => {
              setMessageData({
                type: "error",
                mText: I18n.get("Error"),
                dText: I18n.get("Please contact an administrator"),
              });
              setShowMessage(true);
            });
        }
      })
      .catch((err) => {
        setVerifingCode(false);
        setMessageData({
          type: "error",
          mText: I18n.get("Wrong code!"),
          dText: I18n.get("Please try again"),
        });
        setShowMessage(true);
      });
  }

  const confirmClickHandler = () => {
    hidedSubmitButtonRef.current.click();
  };

  return (
    <div style={{ width: "50%" }}>
      <img
        src={mfa_qr}
        alt="mfa_qr"
        className="dm-auth-mfa-selector-types-image"
      />
      <div className="dm-auth-mfa-selector-title">
        {I18n.get(
          "Escanea el código QR para registrar tu aplicación, y luego introduzca el código de 6 dígitos"
        )}
      </div>
      <div>
        {I18n.get(
          "Una vez conectada, lo recordaremos para que puedas usarlo cada vez que inicies sesión"
        )}
      </div>
      <div className="dm-auth-mfa-qr-container">
        <div>
          {code ? (
            <QRCode
              // size={256}
              style={{ height: "auto", maxWidth: "100%", width: "100%" }}
              value={code}
              viewBox={`0 0 256 256`}
            />
          ) : (
            <LoadingOutlined
              spin
              style={{
                fontSize: 24,
                color: "var(--sky-sky-5)",
                margin: "auto",
                position: "absolute",
                left: "20%",
                top: "45%",
              }}
            />
          )}
        </div>
        <div>
          <div>{I18n.get("Introduce tu código aquí")}</div>
          <div>
            <CodeInput
              onSubmit={submitCodehandler}
              submitButton={
                <button
                  type="submit"
                  style={{ display: "none" }}
                  ref={hidedSubmitButtonRef}>
                  Submit
                </button>
              }
            />
          </div>
        </div>
      </div>
      <DmButton
        disabled={verifingCode || finishRegister}
        loading={verifingCode}
        type="primary"
        className="dm-auth-mfa-confirm-button"
        onClick={confirmClickHandler}>
        {I18n.get("Confirmar")}
      </DmButton>
      {showMessage && showMessageInfo()}
    </div>
  );
};

export default MfaDevice;
